module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAYAAADf/ynVAAAAAXNSR0IArs4c6QAAAVZJREFUWAntmEEOgjAQRS30BO5MvINXYKtegYSdR/AQHoEdCYknULdcwTuYuPMEEJwvdEOAdhIsLGYWStuB/3nT0GTUiiLP821VVRe6jOq63mDOdyil3qRZhGF4juP4pWCqLMsnTa59mxnQ+2itd7oltSbHD3J7gtuBG/463VYtpYrt4SkgtQiKc5qCPoDAA64posDsqblINT6aX+MBnkBskSHGuGURYkKMS4CbL3uMS0zbbsiy7EZf4oMtD+t03t6TJDm65NpyJi0lvUBtE3RdtxKbioCrIZM3KTHz0Cn+xRiXohATYlwC3HzZY1xi1i8/56x0FXc5U2cppcuZaiUmZ2VnH8xSyo6H3qEY68UyMinERuD0LgmxXiwjk8sl1naLf53rkRfwsoQ+LITgCcQKDKghm5oFjH2HaQ63usVi2+kBGrLoqxO+qymrb1rQgzY8wAs8fQHoEnLWLRmL6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/11@2x.png
// module id = KVT6
// module chunks = 199